module.exports = __webpack_public_path__ + "static/media/HelpHeader.0215a6bf.svg";